<template>
    <div class="add-entity">
        <EditDialog :title="title" width="700px" :show="visible">
            <el-form size="mini" ref="form" :model="form" :rules="rules" :show-message="true" label-width="130px">
                <el-form-item label="类型：" prop="EntityType">
                    <el-select @change="clearForm" style="width: 100%" v-model="form.EntityType">
                        <el-option label="商场" :value="3"></el-option>
                        <el-option label="楼层" :value="2"></el-option>
                        <el-option label="店铺" :value="1"></el-option>
                        <el-option label="机构" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <template v-if="form.EntityType != 2">
                    <el-form-item label="名称：" prop="EntityName">
                        <el-input v-model="form.EntityName"></el-input>
                    </el-form-item>
                    <el-form-item label="编码：" prop="EntityCodeEx">
                        <el-input v-model="form.EntityCodeEx"></el-input>
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item label="名称：" prop="EntityName">
                        <el-input v-model="form.EntityName"></el-input>
                    </el-form-item>
                    <el-form-item label="楼层：" prop="EntityCodeEx" class="is-required">
                        <el-select style="width: 100%" v-model="form.EntityCodeEx">
                            <el-option label="-3F" value="-3F"></el-option>
                            <el-option label="-2F" value="-3F"></el-option>
                            <el-option label="-1F" value="-3F"></el-option>
                            <el-option v-for="item of 30" :key="item" :label="item + 'F'" :value="item + 'F'"></el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <el-form-item label="区域：" prop="DistrictID" class="is-required">
                    <district-picker :area-i-d="form.DistrictID" @change="districtChange"></district-picker>
                </el-form-item>
                <el-form-item v-if="form.EntityType != 0" label="面积：" prop="Acreage" class="is-required">
                    <el-input v-model="form.Acreage"></el-input>
                </el-form-item>
                <template v-if="form.EntityType == 3 || form.EntityType == 1">
                    <el-form-item label="开始营业时间：" class="is-required">
                        时:
                        <el-select v-model="form.BizTimeBeginHour">
                            <el-option :value="0" :label="0"></el-option>
                            <el-option v-for="item in 24" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                        分:
                        <el-select v-model="form.BizTimeBeginMin">
                            <el-option :value="0" :label="0"></el-option>
                            <el-option v-for="item in 60" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="结束营业时间：" class="is-required">
                        时:
                        <el-select v-model="form.BizTimeEndHour">
                            <el-option :value="0" :label="0"></el-option>
                            <el-option v-for="item in 24" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                        分:
                        <el-select v-model="form.BizTimeEndMin">
                            <el-option :value="0" :label="0"></el-option>
                            <el-option v-for="item in 60" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <el-form-item label="联系人：" prop="Linkman">
                    <el-input v-model="form.Linkman"></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="Phone">
                    <el-input v-model="form.Phone"></el-input>
                </el-form-item>
                <el-form-item label="上级节点：" prop="ParentID" class="is-required">
                    <TreeSelect
                        node-key="EntityID"
                        label-name="EntityName"
                        :disabled="updateEntity"
                        :tree-data="treeData"
                        :node-id="pId"
                        @select="handleSelect"
                    ></TreeSelect>
                </el-form-item>
                <el-form-item v-if="form.EntityType == 1" label="业态：" prop="BizTypeID">
                    <el-select style="width: 100%" v-model="form.BizTypeID">
                        <el-option v-for="item of bizList" :key="item.ID" :value="item.ID" :label="item.Name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="描述：">
                    <el-input type="textarea" v-model="form.Memo"></el-input>
                </el-form-item>
            </el-form>
            <template #button>
                <div class="dialog-footer">
                    <el-button size="mini" @click="handleSave" style="margin-right: 30px" type="primary">保存</el-button>
                    <el-button size="mini" @click="handleCancel">取消</el-button>
                </div>
            </template>
        </EditDialog>
    </div>
</template>

<script>
export default {
    name: "AddEntity",
    components: {},
    props: {
        visible: {
            type: Boolean,
        },
        updateEntity: {
            type: Object,
        },
        showId: {
            type: String,
        },
    },
    computed: {
        title() {
            if (this.updateEntity) {
                return "修改实体";
            }
            return "新建实体";
        },
    },
    data() {
        let checkArea = (rule, value, callback) => {
            let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
            if (!reg.test(value)) {
                return callback(new Error("必须为正数"));
            } else {
                callback();
            }
        };
        return {
            pNode: null,
            treeData: [],
            bizList: [],
            pId: "",
            form: {
                EntityName: "",
                ParentID: this.showId,
                EntityCodeEx: "",
                EntityType: 1,
                DistrictID: "110101",
                Acreage: 1000,
                BizTimeBeginHour: 6,
                BizTimeBeginMin: 0,
                BizTimeEndHour: 23,
                BizTimeEndMin: 0,
                BizTypeID: "",
                Linkman: "",
                Phone: "",
                Memo: "",
            },
            rules: {
                EntityName: [{ required: true, message: "必填项", trigger: "blur" }],
                Acreage: [{ validator: checkArea, trigger: "blur" }],
            },
        };
    },
    methods: {
        districtChange(obj) {
            this.form.DistrictID = obj.areaID;
        },
        checkForm() {
            if (!this.form.DistrictID) {
                this.$message.error("位置信息请选择到区");
                throw "位置信息请选择到区";
            }
            if (this.form.EntityType == 3 || this.form.EntityType == 1) {
                if (!(this.form.BizTimeBeginHour.toString() && this.form.BizTimeBeginMin.toString())) {
                    this.$message.error("请填写完整开始营业时间");
                    throw "请填写完整开始营业时间";
                }
                if (!(this.form.BizTimeEndHour.toString() && this.form.BizTimeEndMin.toString())) {
                    this.$message.error("请填写完整结束营业时间");
                    throw "请填写完整结束营业时间";
                }
            }
            if (this.form.EntityType == 2) {
                if (!this.form.EntityCodeEx) {
                    this.$message.error("请选择楼层");
                    throw "请选择楼层";
                }
            }
            if (this.form.ParentID == "") {
                this.$message.error("请选择所属上级");
                throw "请选择所属上级";
            }
        },
        handleSelect(node) {
            this.form.ParentID = node.EntityID;
        },
        getSaveUrl() {
            let url = "";
            switch (this.form.EntityType) {
                case 0:
                    url = "/Entity/AddOrg";
                    break;
                case 1:
                    url = "/Entity/AddShop";
                    break;
                case 2:
                    url = "/Entity/AddFloor";
                    break;
                case 3:
                    url = "/Entity/AddMall";
                    break;
            }
            return url;
        },
        handleSave() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    this.checkForm();
                    let params = { ...this.form };
                    if (this.updateEntity) {
                        this.$ajax.post("/Entity/SaveEntity", params).then((res) => {
                            this.$message.success("操作成功");
                            this.$emit("update", res.Data);
                            this.handleCancel();
                        });
                    } else {
                        let url = this.getSaveUrl();
                        this.$ajax.post(url, params).then((res) => {
                            this.$message.success("操作成功");
                            this.$emit("refresh", res.Data);
                            this.handleCancel();
                        });
                    }
                }
            });
        },
        handleCancel() {
            this.form = {
                EntityName: "",
                EntityCodeEx: "",
                EntityType: 1,
                Acreage: 1000,
                BizTimeBeginHour: 10,
                BizTimeBeginMin: 0,
                BizTimeEndHour: 20,
                BizTimeEndMin: 0,
                Linkman: "",
                Phone: "",
                Memo: "",
            };
            this.$emit("update:visible", false);
        },
        getOrgEntityTree() {
            this.$ajax.post("/Entity/GetEntitySelectTree").then((res) => {
                if (res.Data) {
                    this.treeData = [...res.Data];
                    if (this.updateEntity) {
                        this.form = { ...this.updateEntity };
                        if (this.form.ParentID) {
                            this.pId = this.form.ParentID;
                        }
                    }
                    if (this.showId && !this.updateEntity) {
                        this.pId = this.showId;
                        this.form.ParentID = this.showId;
                    }
                }
            });
        },
        getBizModels() {
            this.$ajax.post("/Entity/GetBizModels").then((res) => {
                if (res.Data) {
                    this.bizList = res.Data;
                }
            });
        },
        clearForm() {
            let form = {
                EntityName: "",
                EntityCodeEx: "",
                DistrictID: "110101",
                Acreage: 1000,
                BizTimeBeginHour: 6,
                BizTimeBeginMin: 0,
                BizTimeEndHour: 23,
                BizTimeEndMin: 0,
                BizTypeID: "",
                Linkman: "",
                Phone: "",
                Memo: "",
            };
            this.form = { ...this.form, ...form };
        },
    },
    created() {
        this.getOrgEntityTree();
        this.getBizModels();
    },
};
</script>

<style scoped></style>
